export enum SubscriptionAddonStatus {
  NOT_ACTIVATED = 'NotActivated',
  PENDING = 'Pending',
  ACTIVATED = 'Activated',
}

export interface SubscriptionAddonType {
  id: number
  description: string
  status: SubscriptionAddonStatus
  price: number
}

export interface SubscriptionAddonTypeCommercial {
  id: number
  description: string
  commercial: string
  status: SubscriptionAddonStatus
  price: number
}
